"use strict";

Shopify.theme.jsFooter  = {

  init: function init($section) {
    $('[data-scroll-to-top]').on('click',function(e){
      e.preventDefault()
    	Shopify.theme.jsHeader.disableSticky()
        $([document.documentElement, document.body]).animate({
            scrollTop: 0
        }, 800);
    })
  }
}